import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import flags from "./flags";
import styles from "./FlagIcon.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var FlagIcon = function FlagIcon(_ref) {
  var countryCode = _ref.countryCode,
    label = _ref.label,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size;
  return /*#__PURE__*/_jsx("img", {
    alt: "",
    src: flags[countryCode],
    className: styles[size],
    "data-e2e-name": label ? "flag_icon_".concat(label.toLowerCase().replace(' ', '_')) : ''
  });
};